module.exports = __webpack_public_path__ + "static/media/mars.1a00b708.svg";